import { render, staticRenderFns } from "./AddNewPayService.vue?vue&type=template&id=b63bb1a0&scoped=true"
import script from "./AddNewPayService.vue?vue&type=script&lang=ts"
export * from "./AddNewPayService.vue?vue&type=script&lang=ts"
import style0 from "./AddNewPayService.vue?vue&type=style&index=0&id=b63bb1a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63bb1a0",
  null
  
)

export default component.exports